module.exports = __webpack_public_path__ + "static/media/p3.da1054f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p3.png
// module id = 270
// module chunks = 0